import { Product } from 'common/api/e-comm/models/Product';
import { getCartItemRebate } from 'common/api/e-comm/utils/getCartItemRebate';
import { getCartItemBonus } from 'common/api/e-comm/utils/getCartItemBonus';
import { CartItem, emptyCartItem } from 'common/api/e-comm/models/CartItem';
import { selectedProductOptions } from 'common/utils/amountInput';
import { useStateRebateAdjustment } from 'common/hooks/useStateRebateAdjustment';
import { useCallback } from 'react';

export const useProductRebate = () => {
    const {
        stateRebateAdjustment: { adjustment: adjustLocalProduct },
    } = useStateRebateAdjustment(true);

    const {
        stateRebateAdjustment: { adjustment: adjustNonLocalProduct },
    } = useStateRebateAdjustment(false);

    const calculateProductRebate = useCallback(
        (product: Product) => {
            const adjustment = product.isLocalProduct ? adjustLocalProduct : adjustNonLocalProduct;

            const cartItem: CartItem = {
                ...emptyCartItem,
                selectedOptions: selectedProductOptions(product),
            };

            const rebate = getCartItemRebate(cartItem, product);
            const bonus = getCartItemBonus(cartItem, product);

            const isOnBonus = product.variants.some((v) => v.bonus);

            const activeRebate = bonus?.rebate || rebate;

            return {
                rebate: activeRebate - adjustment,
                isOnBonus,
            };
        },
        [adjustLocalProduct, adjustNonLocalProduct]
    );

    return { calculateProductRebate };
};
